import { Action } from '@ngrx/store';

export const SET_ROUTE = '[ROUTE] set last request url';

export class SetRoute implements Action {
  readonly type = SET_ROUTE;
  constructor(public payload: string) {}
}

export type RouteActions = SetRoute;
